"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var style_1 = require("../style");
exports.Wrapper = styled_components_1.default(style_1.Column)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & .MainSection__Column__LinkWrapper {\n    height: 30px;\n\n    & .MainSection__Column__Link {\n      color: inherit;\n      line-height: 1.875rem;\n      text-decoration: none;\n      vertical-align: middle;\n    }\n  }\n"], ["\n  & .MainSection__Column__LinkWrapper {\n    height: 30px;\n\n    & .MainSection__Column__Link {\n      color: inherit;\n      line-height: 1.875rem;\n      text-decoration: none;\n      vertical-align: middle;\n    }\n  }\n"])));
exports.Wrapper.displayName = 'InfosWrapper';
var templateObject_1;
